import React, {useState, useEffect} from 'react';
import {injectIntl} from "react-intl";
import {useSelector} from "react-redux";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Card, CardBody, CardHeader, CardHeaderToolbar} from "../../../../_metronic/_partials/controls";
import RouteClientConfig from "./RouteClientConfig";
import { fetchRouteClients, fetchRouteClientsPagination } from "../AdminPagesCrud";
import {headerSortingClasses, sortCaret} from "../../../../_metronic/_helpers";
import {PaginationTable} from "../../../components/PaginationTable/PaginationTable";
import * as columnFormatters from "../Suppliers/column-formatters";

function RouteClients({ route }) {
    const [edit, setEdit] = useState(false)
    const [routeClients, setRouteClients] = useState([])

    const initialData = {
        data: [],
        totalCount: 0,
        pageSize: 3

    }

    console.log("Route: ", route)

    const [data, setData] = useState(initialData)
    const {accessToken} = useSelector(
        ({auth}) => ({
            accessToken: auth.authToken,
        })
    )

    const fetchRouteClientPagination = async (queryParams) => {
        await fetchRouteClientsPagination(route._id, queryParams, accessToken).then(response => {
            
            setData({
                data: response.data.data,
                totalCount: response.data.totalCount,
                pageSize: response.data.pageSize
            })
        }).catch(error => console.log(error))
    }


    useEffect(() => {
        

        getRouteClients()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [edit])

    const getRouteClients = async () => {
        await fetchRouteClients(route._id, accessToken).then(response => {
            
            setRouteClients(response.data)
        }).catch(error => console.log(error))
    }

    const columns = [
        {
            dataField: "businessName",
            text: "Company",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "businessEmail",
            text: "Email",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
    ];

    const sizePerPageList = [
        {text: "3", value: 3},
        {text: "5", value: 5},
        {text: "10", value: 10}
    ]

    let initialFilter = {
        filter: {
            searchText: ""
        },
        sortOrder: "asc",
        sortField: "name",
        pageNumber: 1,
        pageSize: 10,
    }

    const sorting = [{dataField: "name", order: "asc"}]
    const pagination = {custom: true, sizePerPageList: sizePerPageList}
    const tableClasses = "table table-head-custom table-head-bg table-borderless table-vertical-center "

    const prepareFilter = (queryParams, values) => {
        const {searchText} = values;
        const newQueryParams = {...queryParams};
        const filter = {};

        filter.searchText = searchText ?? "";

        newQueryParams.filter = filter;
        return newQueryParams;
    }

    return (
        <>
            {edit ?  <RouteClientConfig route={route} currentRouteClients={routeClients} setEdit={setEdit}
                    /> :
                <Card>
                    <CardHeader title="Price List Clients">
                        <CardHeaderToolbar>
                            <button type="button" className="btn btn-primary" onClick={() => setEdit(true)}>
                                Edit
                            </button>
                        </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>
                        <PaginationTable
                            data={data}
                            columns={columns}
                            pagination={pagination}
                            isLoading={false}
                            sorting={sorting}
                            initialFilter={initialFilter}
                            tableClasses={tableClasses}
                            fetcher={fetchRouteClientPagination}
                            filterFunction={prepareFilter}
                            searchField={true}/>
                    </CardBody>
                </Card>
            }
        </>
    );
}

export default injectIntl(RouteClients);